export const TipoServicios = {
    HotelAeropuerto : 'Hotel-Aeropuerto',
    AeroPuertoHotel : 'Aeropuerto-Hotel',
    HotelHotel : 'Hotel-Hotel',
    RoundTrip: 'Roundtrip'
}